import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";
import LongHand from "../../../../../../assets/longHand.png";
import "./SortScoopCard.scss";

const SortScoopCard = ({
  career,
  title,
  text,
  rating,
  onRatingChange,
  onDecide,
  dragX = 0,
  dragging = false,
  exitDirection = null,
  peek = false,
}) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(false);
  }, [career?.id]);

  if (peek) {
    return (
      <div className="sort-scoop-card sort-scoop-card--peek">
        <h2 className="sort-scoop-card__title">{title}</h2>
      </div>
    );
  }

  const rotate = dragX / 18;
  const overlayOpacity = Math.min(Math.abs(dragX) / 90, 1);
  const overlayLabel = dragX > 0 ? "SAVE" : dragX < 0 ? "SKIP" : "";
  let transform = `translateX(${dragX}px) rotate(${rotate}deg)`;
  let opacity = 1;
  if (exitDirection === "right") {
    transform = "translateX(520px) rotate(22deg)";
    opacity = 0;
  } else if (exitDirection === "left") {
    transform = "translateX(-520px) rotate(-22deg)";
    opacity = 0;
  } else if (exitDirection === "down") {
    transform = "translateY(400px)";
    opacity = 0;
  }

  return (
    <div
      className="sort-scoop-card"
      style={{
        transform,
        opacity,
        transition: dragging ? "none" : "transform 420ms cubic-bezier(.2,.7,.3,1), opacity 420ms",
      }}
    >
      {overlayLabel ? (
        <div
          className={classNames(
            "sort-scoop-card__swipe-label",
            overlayLabel === "SAVE" ? "sort-scoop-card__swipe-label--save" : "sort-scoop-card__swipe-label--skip"
          )}
          style={{ opacity: overlayOpacity }}
        >
          {overlayLabel}
        </div>
      ) : null}
      <img src={LongHand} alt="" className="sort-scoop-card__icon" />
      <h2 className="sort-scoop-card__title">{title}</h2>
      <p className={classNames("sort-scoop-card__blurb", { "sort-scoop-card__blurb--open": expanded })}>
        {text || "Open your profile page to read the full career scoop."}
      </p>
      <button type="button" className="sort-scoop-card__more" onClick={() => setExpanded((open) => !open)}>
        {expanded ? "Show less" : "Show more"}
      </button>
      <Link className="sort-scoop-card__profile" to={`/profile/recommendations/career/${career?.id}`}>
        More on your profile page
      </Link>
      <p className="sort-scoop-card__prompt">Is this career path for you?</p>
      <input
        type="range"
        className="sort-scoop-card__slider"
        min={1}
        max={5}
        step={1}
        value={rating}
        onChange={(event) => onRatingChange(Number(event.target.value))}
        onMouseDown={(event) => event.stopPropagation()}
        onTouchStart={(event) => event.stopPropagation()}
      />
      <div className="sort-scoop-card__ticks">
        <span>1</span>
        <span>2</span>
        <span>3</span>
        <span>4</span>
        <span>5</span>
      </div>
      <button type="button" className="sort-scoop-card__save" onClick={() => onDecide("save")}>
        Save this Career
      </button>
      <div className="sort-scoop-card__row">
        <button type="button" className="sort-scoop-card__skip" onClick={() => onDecide("skip")}>
          Skip
        </button>
        <button type="button" className="sort-scoop-card__maybe" onClick={() => onDecide("maybe")}>
          Maybe
        </button>
      </div>
    </div>
  );
};

export default SortScoopCard;
